import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Main.vue')
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('./views/auth/Index.vue')
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('./views/auth/Callback.vue')
    },
    {
      path: '/channel',
      name: 'ChannelMain',
      component: () => import('./views/channel/Index.vue')
    }
  ]
})

export default router
